export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#020202',
    light: '#e5f2fa',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FEFFFA',
    contrastText: '#0A5285',
    light: '#D9EDF7',
  },
  text: {
    primary: '#0E2E3B',
    secondary: '#343538',
    tertiary: '#64748B',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    arrow: '#292D32',
  },
  divider: 'rgba(52, 53, 56, 0.4)',
  background: {
    main: '#B4C08F',
    card: '#FAFAEE',
    paper: '#FFF',
    default: '#FFF',
    header:
      'linear-gradient(to right, rgba(160, 182, 188, 1), rgba(217, 225, 221, 1))',
    footer: '#FAFAEE',
    level2: '#f7f8fb',
    level1: 'rgba(255, 255, 255, 0.6)',
    steps: '#43C2BD',
    tableHead: '#B4C08F',
    tableSubhead: '#F7F7F7',
    tableBorder: '#7D808880',
    tableAlternate: '#F8F8F8',
    alternate: '#d4f1f9',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#B4C08F',
    secondary: 'rgb(240,243,243)',
    light: '#FEFFFA',
    divider: '#D9DBE9',
    secondaryLight: '#F9F9ED',
    footerSecondary: '#343538',
    arrow: '#BACE60',
    tertiaryLight: '#F9F9F5',
    howItWorks: '#F0E6CE',
  },
  verticalBar: {
    used: '#020202',
    unused: '#e5e5e5',
    unlimited: '#C0C0C0',
  },
};
